import React, { Suspense } from "react";
import { Route, Routes } from "react-router";
import { useAppSelector } from "../../redux/hooks";
import { RegistrationComplete } from "../authentication/RegistrationComplete";
import { SearchResultsProvider } from "../global/searchresults/SearchResultsContext";
const ApiKeys = React.lazy(() => import("../apiKeys/ApiKeys"));
const MyAccount = React.lazy(() => import("../account/MyAccount"));
const Dashboard = React.lazy(() => import("../dashboard/Dashboard"));
const Licenses = React.lazy(() => import("../licenses/Licenses"));
const ViridisLogin = React.lazy(() => import("../login/ViridisLogin"));
const Pocketbook = React.lazy(() => import("../pocketbook/Pocketbook"));
const ChemPredictor = React.lazy(
    () => import("../chempredictor/ChemPredictor")
);
const Agent = React.lazy(() => import("../agent/Agent"));
const ReactionAnalyzer = React.lazy(
    () => import("../reaction-analyzer/ReactionAnalyzer")
);
const NotebookApp = React.lazy(() => import("../notebook/NotebookApp"));
const SDSApp = React.lazy(() => import("../sds/SDSApp"));
const UserAdmin = React.lazy(() => import("../userAdmin/UserAdmin"));
const GlobalHeader = React.lazy(() => import("./GlobalHeader"));
const ViridisChemAdmin = React.lazy(
    () => import("../viridischemadmin/ViridisChemAdmin")
);

const AppWithHeader = (App: React.ComponentType) => {
    const AppWithHeaderComponent = () => (
        <div>
            <Suspense fallback={<div />}>
                <GlobalHeader />
            </Suspense>
            <Suspense fallback={<div />}>
                <App />
            </Suspense>
        </div>
    );
    return AppWithHeaderComponent;
};

const DashboardWithHeader = AppWithHeader(Dashboard);
const PocketbookWithHeader = AppWithHeader(Pocketbook);
const ChemPredictorWithHeader = AppWithHeader(ChemPredictor);
const AgentWithHeader = AppWithHeader(Agent);
const ReactionAnalyzerWithHeader = AppWithHeader(ReactionAnalyzer);
const NotebookAppWithHeader = AppWithHeader(NotebookApp);
const SDSAppWithHeader = AppWithHeader(SDSApp);
const LicensesWithHeader = AppWithHeader(Licenses);
const UserAdminWithHeader = AppWithHeader(UserAdmin);
const MyAccountWithHeader = AppWithHeader(MyAccount);
const ApiKeysWithHeader = AppWithHeader(ApiKeys);
const ViridisChemAdminWithHeader = AppWithHeader(ViridisChemAdmin);

export const ViridisApp = () => {
    const userName = useAppSelector((state) => state.user?.userName);

    if (!userName) {
        return (
            <div className="whiteBG">
                <Suspense fallback={<div />}>
                    <ViridisLogin createAccount />
                </Suspense>
            </div>
        );
    } else {
        return (
            <SearchResultsProvider>
                <div>
                    <Routes>
                        <Route index Component={DashboardWithHeader} />
                        <Route
                            path="registration-complete"
                            Component={RegistrationComplete}
                        />
                        <Route path="chemicals">
                            <Route index Component={PocketbookWithHeader} />
                            <Route
                                path=":chemicalId"
                                Component={PocketbookWithHeader}
                            />
                        </Route>
                        <Route
                            path="reactions"
                            Component={ReactionAnalyzerWithHeader}
                        />
                        <Route
                            path="notebooks"
                            Component={NotebookAppWithHeader}
                        />
                        <Route
                            path="chempredictor"
                            Component={ChemPredictorWithHeader}
                        />
                        <Route path="sds" Component={SDSAppWithHeader} />
                        <Route path="agent" Component={AgentWithHeader} />
                        <Route path="licenses" Component={LicensesWithHeader} />
                        <Route path="users" Component={UserAdminWithHeader} />
                        <Route
                            path="myaccount"
                            Component={MyAccountWithHeader}
                        />
                        <Route path="apiKeys" Component={ApiKeysWithHeader} />
                        <Route
                            path="viridischem_admin/*"
                            Component={ViridisChemAdminWithHeader}
                        />
                    </Routes>
                </div>
            </SearchResultsProvider>
        );
    }
};
